export class RatingsError extends Error {}
